import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import { useStyles } from './styles';

const Input = props => {
  const {
    input,
    label,
    isHiddenErrorMsg,
    maxLength,
    isOnlyNumber,
    isPhoneNumber,
    className,
    labelClass,
    inputClass,
    mask,
    placeholder,
    meta: { touched, error, submitFailed },
    ...otherProps
  } = props;
  const classes = useStyles();
  const [t] = useTranslation();

  const onChangeHandler = e => {
    const { value } = e.target;

    if (isPhoneNumber && value) {
      const reg = /^[0-9+ ]*$/;
      if (
        !reg.test(value) &&
        (value.length > 1 || (value.length === 1 && value[0] !== '+'))
      ) {
        return;
      }
    } else if (isOnlyNumber) {
      input.onChange(value.replace(/\D/g, ''));
      return;
    }

    input.onChange(value);
  };

  return (
    <div className={classNames(classes.root, className)}>
      {label && (
        <InputLabel
          className={classNames(classes.label, labelClass)}
          htmlFor={`${label}-input`}
          disabled={otherProps.disabled}
          classes={{
            disabled: classes.disabledLabel
          }}
        >
          {t(label)}
        </InputLabel>
      )}
      <InputBase
        classes={{
          root: classNames(
            classes.inputRoot,
            {
              [classes.error]:
                (submitFailed || (touched && !isHiddenErrorMsg)) && error
            },
            inputClass
          ),
          focused: classes.inputRootFocused,
          input: classes.input,
          disabled: classes.disabledInput
        }}
        inputProps={{
          mask: mask,
          maxLength: isOnlyNumber ? maxLength : 255
        }}
        id={`${label}-input`}
        placeholder={t(placeholder)}
        {...input}
        {...otherProps}
        onChange={onChangeHandler}
      />
      {!isHiddenErrorMsg && (touched || submitFailed) && error && (
        <FormHelperText error>{t(error)}</FormHelperText>
      )}
    </div>
  );
};

export default Input;
